import { http } from '../../config/axios'

export default function postParametroAplicacao(parametroAplicacao: any): Promise<string> {
  return http
    .post('api/parametroaplicacao', parametroAplicacao)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post parametro aplicacao', error)
      throw Error(error.response.data)
    })
}
